import { CommonExport } from '../common/common-export.service';
import { setLastExportId } from 'modules/export/storage/last-export.storage';
import { ApiClientService } from '@dfl/react-security';

export interface DownloadStatusResponse {
  total: number;
  page: number;
  data: Array<{
    _id: string;
    status: 'PENDING' | 'IN_PROGRESS' | 'DONE' | 'ERROR';
  }>;
}

export class InventoryDownloadService extends CommonExport<any> {
  _downloadFileToExcel = (id: string, name?: string) =>
    this.downloadFileToExcel({
      name: name ?? 'products',
      path: `/download/download/${id}`,
    });

  checkDownloadStatus = (ids: string[]): Promise<DownloadStatusResponse> => {
    return this.handleResponse(
      ApiClientService.post(this.getPath('/download/download/status'), { ids })
    );
  };

  _downloadFileToPDF = (id: string, name?: string) =>
    this.downloadFileToPdf({
      name: name ?? 'orders',
      path: `/download/download/${id}`,
    });

  // inicial path export
  _getExportPath = async (params: any, path?: string) => {
    const response = await this.getExportPath(path ?? '/products/export', params);
    if (response?._id) {
      setLastExportId(response._id);
    }
    return response;
  };

  _generateDownload = () => this.generateDownload('/products/export/');
}

export default new InventoryDownloadService('/ms-inventory/api');
